import React from 'react';
import { Loader } from 'lucide-react';

export const LoadingScreen: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
      <div className="text-center">
        <Loader className="w-12 h-12 text-primary animate-spin mx-auto" />
        <p className="mt-4 text-gray-600">جارٍ التحميل...</p>
      </div>
    </div>
  );
};